export const RESCUE_AREAS = {
    BASE: 'v1/rescue-areas',
    WITHIN_BOUNDS: 'v1/rescue-areas/within-bounds',
    WITHIN_RADIUS: 'v1/rescue-areas/within-radius',
  }
  